import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row,
    Card,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";
import styles from './styles.module.scss';
import React from 'react'
import PhoneIcon from '/public/site-assets/svg/phone.svg';
import Mail from '/public/site-assets/svg/mail.svg';
import Share from '/public/site-assets/svg/share.svg';
import LinkedIn from '/public/site-assets/svg/linkedin.svg';
import Link from "next/link"

export default function AllClientsByJobSearch({
    global,
    pathPrefix,
    customClass = "",
    post,
    content
}) {
    return (
        post.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    {content ?
                        <div className="mb-4">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                {content}
                            </SourceFlowText>
                        </div> : ""}
                    <Row className="p-md-5 p-2 py-3 rounded-3 m-0">
                        {post.map((post, index) =>
                            <Col md={4} key={index} className="mb-4">
                                <Card className="rounded-3 h-100">
                                    <Link href={`/client-page/${post.url_slug}`}>
                                        <a className="text-decoration-none">
                                            <SourceFlowImage
                                                src={post?.what_makes_it_different_logo ? post.what_makes_it_different_logo : "/site-assets/images/image-placeholder.webp"}
                                                alt={post?.title}
                                                size="500x"
                                                className={`card-img rounded-0 w-50 mt-4 mb-3`}
                                            />
                                            <hr></hr>
                                            <div className="px-4 pb-2">
                                                <p className="fs-6"><strong>{post.title}</strong></p>
                                                {post?.short_description ?
                                                    <div className="description" dangerouslySetInnerHTML={{ __html: post?.short_description }} />
                                                    : ""}
                                            </div>
                                        </a>
                                    </Link>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </Container>
            </section>
        )
    )
}